import styled from 'styled-components';
import { Colors } from '../constants/colors';
import { Check } from '@material-ui/icons';
import React from 'react';

const UncheckedCheckMark = styled.div`
  border-width: 1px;
  border-style: solid;
  border-color: ${Colors.grey};
  min-width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 20px;
  padding-top: 2px;
`;

export const CheckedCheckMark = styled(UncheckedCheckMark)`
  background: ${Colors.primary};
  border-color: ${Colors.primary};

  svg {
    fill: ${Colors.white};
    height: 90%;
  }
`;

export const CheckMark = ({ active }: { active?: boolean }) => active ? <CheckedCheckMark><Check /></CheckedCheckMark> : <UncheckedCheckMark />;
